import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen bg-[#0B1020]">
      <div className="absolute inset-0 bg-grid opacity-40" />
      <div className="relative mx-auto flex min-h-screen max-w-md flex-col justify-center px-4 py-10">
        <Link to="/" className="mx-auto mb-8"><Logo size={96} /></Link>
        <div className="rounded-2xl border border-[#2A3655] bg-[#141B2D] p-6 sm:p-8">
          <h1 className="font-display text-2xl font-bold text-[#F8FAFC]">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-[#CBD5E1]">{subtitle}</p>}
          <div className="mt-6">{children}</div>
        </div>
        {footer && <div className="mt-5 text-center text-sm text-[#94A3B8]">{footer}</div>}
      </div>
    </div>
  );
}
